export const moduleConfig = {
    entityKey: 'applications',
    localStorageKey: 'pac-applications',
    schemaVersion: '1.0.0',
}